import { mapIntegrationProviderFromDTO } from '@/modules/common/mappers/integration.mapper';

import { WorklogIntegrationResponse } from '../types/dto/worklogs-summary.dto';
import { WorklogIntegrationStatus } from '../types/time-tracking';

/**
 * Maps the raw integration links DTO to the one domain status worth surfacing in the UI.
 * A worklog can only ever be synced from a single external source, so only the first link
 * is considered — later entries (if any) don't change what the user needs to see.
 */
export const mapWorklogIntegrationStatus = (
  integrations?: WorklogIntegrationResponse[]
): WorklogIntegrationStatus | undefined => {
  const [link] = integrations ?? [];
  if (!link) return undefined;

  return {
    service: mapIntegrationProviderFromDTO(link.integrationProviderType),
    isConnected: !link.deletedAt,
  };
};
